import React, {useState, useEffect, useRef} from 'react';
import VIDABOO_CONSTANTS from '../../../config/consts';
import AutocompleteDropdownComponentRender from './autocompleteDropdownComponentRender';

const AutocompleteDropdownComponent = ({
  displayLabel = false,
  enableAutoComplete = false,
  isDisabled = false,
  isMultiSelect = false,
  value = '',
  options,
  title = 'Select from Options',
  selectedOption,
  selectedItemIds = [],
  labelKey = 'label',
  valueKey = 'value',
  tooltipText = '',
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [dropDownData, setDropDownData] = useState(options ? options : []);
  const [viewDropdown, setViewDropdown] = useState(false);
  const [multipleSelectedOptions, setMultipleSelectedOptions] = useState([]);
  const [showlabel, setShowLabel] = useState(true);
  const [showTooltipComponent, setShowTooltipComponent] = useState(false);

  const lastValue = useRef(value);

  const inputRef = useRef();

  useEffect(() => {
    setDropDownData(options ?? []);
  }, [options]);

  useEffect(() => {
    setInputValue(value);
    setSelectedLabelForInput(value);
    lastValue.current = value;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const setSelectedLabelForInput = (selectedValue) => {
    const selectedOption = dropDownData.find(
      (option) => option[valueKey] === selectedValue,
    );
    selectedOption && setSelectedLabel(selectedOption[labelKey]);
  };
  const handleTooltip = () => {
    setShowTooltipComponent(!showTooltipComponent);
  };

  const filterData = (list, searchValue) => {
    let filteredData;
    filteredData = list.filter((item) =>
      item[labelKey].toLowerCase()?.includes(searchValue.toLowerCase()),
    );
    if (filteredData.length) {
      setDropDownData(filteredData);
      setViewDropdown(true);
    } else {
      setDropDownData([
        {[valueKey]: 'disabled', [labelKey]: 'No Options Available'},
      ]);
    }
  };

  const handleChange = (e) => {
    const inputValue = VIDABOO_CONSTANTS.NATIVE_APP ? e : e.target.value;

    setInputValue(inputValue);

    if (options.length >= 10) {
      if (inputValue !== ' ' || inputValue !== '') {
        filterData(options, inputValue);
      }
    }
  };

  const clearSearch = () => {
    setInputValue('');
    filterData(options, '');
    inputRef.current && inputRef.current.focus();
  };

  const handleFocus = () => {
    // workaround for closing already opened dropdowns on page
    // FUTURE SCOPE: find better solution for this.
    if (!isDisabled) {
      if (!VIDABOO_CONSTANTS.NATIVE_APP) {
        const overlayElement = document.getElementById(
          'et-autocomplete-dropdown-overlay',
        );
        overlayElement?.click();
      }
      clearSearch();
      setViewDropdown(true);
      setShowLabel(false);
    }
  };

  const handleBlur = () => {
    setViewDropdown(false);
    setInputValue(lastValue.current);
  };

  const handleMultiSelection = (item) => {
    let selectedOptionsArray = [...multipleSelectedOptions];
    if (selectedOptionsArray.includes(item)) {
      const rmIndex = selectedOptionsArray.indexOf(item);
      selectedOptionsArray.splice(rmIndex, 1);
    } else {
      selectedOptionsArray.push(item);
    }
    const valueList = [];
    selectedOptionsArray.forEach((item) => valueList.push(item[labelKey]));
    if (selectedOption) {
      selectedOption({target: {value: selectedOptionsArray}});
      setMultipleSelectedOptions(selectedOptionsArray);
      lastValue.current = valueList.join(', ');
    }
  };

  const handleSingleSelection = (item) => {
    setViewDropdown(false);
    if (item[labelKey] !== 'No Options Available') {
      if (!item.isNonSelectable) {
        if (
          selectedOption &&
          (item[labelKey] !== lastValue.current || item.id)
        ) {
          selectedOption({
            target: {label: item[labelKey], value: item[valueKey]},
          });
          lastValue.current = item[labelKey];
        }
        if (displayLabel) {
          setSelectedLabelForInput(item[valueKey]);
        }
        setInputValue(item[labelKey]);
      } else {
        selectedOption({
          target: {label: item[labelKey], value: item[valueKey]},
        });
        setInputValue(lastValue.current);
      }
    }
  };

  const handleClick = (item) => {
    if (isMultiSelect) {
      handleMultiSelection(item);
    } else {
      handleSingleSelection(item);
    }
  };
  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      handleSingleSelection(dropDownData[0]);
    }
  };
  return (
    <AutocompleteDropdownComponentRender
      displayLabel={displayLabel}
      enableAutoComplete={enableAutoComplete}
      isDisabled={isDisabled}
      isMultiSelect={isMultiSelect}
      title={title}
      selectedItemIds={selectedItemIds}
      labelKey={labelKey}
      valueKey={valueKey}
      tooltipText={tooltipText}
      viewDropdown={viewDropdown}
      handleBlur={handleBlur}
      handleKeyDown={handleKeyDown}
      inputRef={inputRef}
      inputValue={inputValue}
      handleChange={handleChange}
      handleFocus={handleFocus}
      showlabel={showlabel}
      selectedLabel={selectedLabel}
      handleTooltip={handleTooltip}
      showTooltipComponent={showTooltipComponent}
      dropDownData={dropDownData}
      handleClick={handleClick}
      multipleSelectedOptions={multipleSelectedOptions}
      lastValue={lastValue}
    />
  );
};

export default AutocompleteDropdownComponent;
